import { buildProps, definePropType } from '@pit-element-plus/utils'
import type { FormBaseColumns } from './form-base'

export type TableLoadFn = (row: any) => Promise<any>

export const formBaseTableProps = buildProps({
  primaryKey: {
    type: String,
    default: 'id',
  },
  rowKey: String,
  rowSingle: {
    type: Boolean,
    default: true,
  },
  tableData: Array,
  columns: {
    type: definePropType<FormBaseColumns>(Array),
  },
  selectionWidth: {
    type: Number,
    default: 60,
  },
  selectionAlign: {
    type: String,
    default: 'center',
  },
  selectionFixed: {
    type: [String, Boolean],
    default: false,
  },
  /**
   * @description 是否展开树形表格
   */
  defaultExpandAll: {
    type: Boolean,
    default: true,
  },
  indexWidth: {
    type: Number,
    default: 60,
  },
  indexAlign: {
    type: String,
    default: 'center',
  },
  indexFixed: {
    type: [String, Boolean],
    default: false,
  },
  pagination: Object as any,
  noPagination: {
    type: Boolean,
    default: true,
  },
  tableLazy: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 是否懒加载子节点数据
   */
  isVirtuallyTable: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 自动将列表转为树结构（支持虚拟滚动）
   */
  tableTransform: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 是否隐藏序号
   */
  noTableIndex: {
    type: Boolean,
    default: true,
  },
  tableLoad: {
    type: definePropType<TableLoadFn>(Function),
  },
  spanMethod: {
    type: Function,
  },
  rowClassName: {
    type: Function,
  },
  cellClassName: {
    type: Function,
  },
} as const)

export const formBaseTableEmits = {
  'size-change': (val: number) => val,
  'current-change': (val: number) => val,
  'table-current-change': (row: any) => row,
  'table-row-dblclick': (row: any) => row,
  'table-selection-change': (row: any) => row,
  'table-selection-all': (val: any) => val,
  'click-info': (columns: any, row: any) => columns && row,
  'table-sort-change': (val: any) => val,
}
